<template>
    <ModalFormCard :action="'/deal/' + editingModel.id" :submittedCallback="submittedCallback" class="modal-default wide">
        <template #title>Delete deal</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="_method" value="DELETE" />

            <template v-if="step == 1">
                <div class="flex items-center">
                    <IconErrorCircle />
                    <p class="font-bold text-16 pl-3">Please read carefully</p>
                </div>

                <p class="text-15 pt-4">
                    Deals should only be deleted if they haven’t been won or lost, i.e. you should only delete a deal if you’ve created it by
                    mistake.
                </p>

                <p class="text-15 pt-4">
                    If you’ve created a genuine deal, it’s important to mark that deal as either Won or Lost, so that it appears in your
                    reporting.
                </p>

                <p class="text-15 pt-4">You can use your reporting page to discover areas in your business that can be improved.</p>

                <p class="text-15 pt-4">
                    If you’re still unsure, Read this
                    <a
                        href="https://support.zapo.com/en/articles/181635-marking-deals-as-won-or-lost-and-when-you-should-delete-them"
                        target="_blank"
                        class="link-text text-purple-600"
                        >article</a
                    >
                </p>

                <div class="modal-buttons">
                    <button :disabled="saving || stepping" class="button-black default" type="button" @click="$emit('close')">Cancel</button>

                    <ButtonSaving :saving='saving || stepping' type="button" @click='goToStep(2)' class="button-purple default">Delete deal</ButtonSaving>
                </div>
            </template>

            <template v-if="step == 2">
                <div class="flex items-center justify-center pt-6">
                    <div class="relative">
                        <IconAlert class="stroke-attention absolute -left-8 top-px" />
                        <p class="text-19 font-hero text-center">Warning</p>
                    </div>
                </div>

                <p class="text-14 text-center pt-4 border-b border-grey-500 pb-10">
                    You are about to permanently delete "{{ editingModel.getName() }}", you can’t undo this.
                </p>

                <p class="mt-6 text-14 font-semibold">If you proceed, you will delete:</p>

                <template v-if="deleting != null">
                    <p class="text-13 pt-1.5">- {{ deleting.sms || 0 }} SMS message{{ deleting.sms != 1 ? 's' : '' }}</p>
                    <p class="text-13 pt-1.5">- {{ deleting.notes || 0 }} Note{{ deleting.notes != 1 ? 's' : '' }}</p>
                    <p class="text-13 pt-1.5">- {{ deleting.tasks || 0 }} Task{{ deleting.tasks != 1 ? 's' : '' }}</p>
                    <p class="text-13 pt-1.5">- {{ deleting.appointments || 0 }} Appointment{{ deleting.appointments != 1 ? 's' : '' }}</p>
                    <p class="text-13 pt-1.5">- {{ deleting.files || 0 }} File{{ deleting.files != 1 ? 's' : '' }}</p>
                </template>

                <p class="pb-1 mt-4 text-13 text-grey-900">
                    Type '<span class="text-black">{{ editingModel.contact.fullName() }}</span
                    >' to delete this deal
                </p>

                <Input placeholder="Enter your prospect's name" class="" name="name" groupClass="bg-grey text-15" :canFoucs="false" />

                <input type="hidden" name="_method" value="delete" />

                <div class="modal-buttons">
                    <ButtonSaving :disabled="saving" class="button-black default h-12" name="redirect_after" value="1">Delete deal</ButtonSaving>
                    
                    <button :disabled="saving" type="button" class="button-purple default" @click="$emit('close')">Cancel</button>
                </div>
            </template>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'
import Deal from '~/models/deal.js'

export default {
    mixins: [Modal],
    data() {
        return {
            value: Deal.form(this.editingModel),
            step: 1,
            stepping: false,
            deleting: {}
        }
    },

    methods: {
        goToStep(step) {
            this.stepping = true;

            this.$axios.get('/actions/deal-before-delete/' + this.editingModel.id).then((res) => {
                this.deleting = res
                this.step = 2
                this.stepping = false;
            })
        },

        submittedCallback(res, event) {
            if (this.$route.path.indexOf('/deal/') >= 0) {
                this.redirectAfterSubmit(event, '/prospects/' + this.editingModel.contact.id)
            }

            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        }
    }
}
</script>